import {
    GET_PACKAGE_ERROR,
    GET_PACKAGE_START,
    GET_PACKAGE_SUCCESS,
} from "../actions/userPackage";

interface Payload {
    credits?: number;
    negative_credits?: boolean;
    packages?: PackagePayload[];
}

interface PackagePayload {
    id?: number;
    family?: string;
    limit?: number;
    absolute?: boolean;
    used?: number;
}

export type UserPackageAction =
    | { type: typeof GET_PACKAGE_START }
    | { type: typeof GET_PACKAGE_SUCCESS; payload: Payload }
    | { type: typeof GET_PACKAGE_ERROR };

interface UserPackageState {
    credits?: number;
    negative_credits?: boolean;
    packages?: PackagePayload[];
    isLoadingPackage: boolean;
}

const initialState: UserPackageState = {
    credits: 0,
    negative_credits: false,
    packages: [],
    isLoadingPackage: false,
};

const userPackage = (state = initialState, action: UserPackageAction) => {
    switch (action.type) {
        case GET_PACKAGE_START:
            return { isLoadingPackage: true };
        case GET_PACKAGE_SUCCESS:
            return { ...state, ...action.payload, isLoadingPackage: false };
        case GET_PACKAGE_ERROR:
            return initialState;
        default:
            return state;
    }
};
export default userPackage;
